import { t } from '@avalara/bat-apps-shared/i18n';
import { SDialog } from '@avalara/skylab-sdk/react';

type DialogProps = {
  customerAccountId: string;
  dialogOpen: boolean;
  schedulingInProgress: boolean;
  handleDismissDialog: () => void;
};

const ScheduleDialog = (dialogProps: DialogProps) => {
  const { dialogOpen, schedulingInProgress, handleDismissDialog } = dialogProps;
  return (
    <SDialog
      id='schedule-call-dialog'
      data-ref='buy.accounts-payable.schedule-call.dialog'
      onS-dismiss={handleDismissDialog}
      open={dialogOpen}
      style={{ maxHeight: '90vh' }}
    >
      <div slot='header' data-ref='buy.accounts-payable.schedule-call.dialog-header'>
        {t('client.buttons.get-avatax-for-accounts-payable')}
      </div>
      <div
        slot='body'
        id='schedule-call-dialog-body'
        data-ref='buy.accounts-payable.schedule-call.dialog-body'
        className='flex flex-dir-col'
      >
        <p className='font-light'>{t('client.general.schedule-a-call-with-an-account-representative-to-buy-or-lea')}</p>
        <p className='font-light pad-bottom-lg'>
          {t('client.general.avatax-for-accounts-payable-features-pricing-and-setup')}
        </p>
        <div id='chilipiper-calendar' data-ref='buy.accounts-payable.schedule-call.chilipiper-calendar' />
      </div>
      <div slot='footer' data-ref='buy.accounts-payable.schedule-call.dialog-footer'>
        <button
          type='button'
          data-ref='buy.accounts-payable.schedule-call.dialog-close-button'
          className='secondary'
          disabled={schedulingInProgress}
          onClick={handleDismissDialog}
        >
          {t('client.buttons.close')}
        </button>
      </div>
    </SDialog>
  );
};

export default ScheduleDialog;
